/**
 * Modern (v4) UIKit chat selectors — internal implementations.
 *
 * These are consumed by the facade selectors in domain/chat/chatSelector.js.
 * Do not import directly from components — use the facades instead.
 */
import { Map } from 'immutable';
import { selector } from 'lib/selectors';

const chat = (state) => state.chat;
const documents = (state) => state.documents;

// V4: derives from chat.unreadDocuments (Immutable.Map<companyId, Immutable.Map<documentId, count>>).
// Returns the current company's per-document unread map. Presence of a documentId (Map.has)
// means it has unread; its value is the unread message count for that document.
export const modernDocumentsUnreadSelector = selector(chat, documents, (c, d) =>
  c.get('unreadDocuments').get(d.companyId) || Map(),
);

// V4: unread message count for the CURRENTLY OPEN document — the sum of unread across all
// channels carrying this documentId (already summed into unreadDocuments by companyId+documentId).
export const modernCurrentDocumentUnreadSelector = selector(chat, documents, (c, d) =>
  c.get('unreadDocuments').getIn([d.companyId, d.document.documentID]) || 0,
);

// V4: derives from chat.unreadCompanies (Immutable.Map<companyId, count>)
export const modernCompanyUnreadSelector = selector(chat, (c) => c.get('unreadCompanies') || Map());

// V4: reads from chat.totalUnreadCount populated by REST + WS push
export const modernTotalUnreadSelector = selector(chat, (c) => c.get('totalUnreadCount') || 0);

// V4: extracts unread count for the current companyId from unreadCompanies map
export const currentCompanyUnreadSelector = selector(chat, documents, (c, d) =>
  (c.get('unreadCompanies') || Map()).get(d.companyId) || 0,
);
